/* Brands Only — kleine UI-fixes */
(function () {
  // "Verder winkelen" in de lege winkelmandlade: lade sluiten; als de link naar deze pagina wijst, niet herladen.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#cart-drawer .cart-items__wrapper--drawer-empty a, #cart-drawer .cart-drawer--empty a.button');
    if (!a) return;
    var drawer = a.closest('theme-drawer');
    var dlg = drawer && drawer.querySelector('dialog');
    var same = a.pathname === location.pathname;
    if (same) e.preventDefault();
    try { if (drawer && typeof drawer.closeDialog === 'function') drawer.closeDialog(); else if (dlg && dlg.open) dlg.close(); } catch (err) { if (dlg && dlg.open) dlg.close(); }
  }, true);
  // Filterknoppen bovenaan (collecties en zoeken): één lijst tegelijk open, sluiten bij klik erbuiten of Escape.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('[data-bo-topfilters] details') || !d.open) return;
    d.closest('[data-bo-topfilters]').querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
  }, true);
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-bo-topfilters] details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-bo-topfilters] details[open]').forEach(function (d) { d.removeAttribute('open'); });
  });
})();
